import { render, staticRenderFns } from "./StereoVideo.vue?vue&type=template&id=c2e25c86&scoped=true&"
import script from "./StereoVideo.vue?vue&type=script&lang=ts&"
export * from "./StereoVideo.vue?vue&type=script&lang=ts&"
import style0 from "./StereoVideo.vue?vue&type=style&index=0&id=c2e25c86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2e25c86",
  null
  
)

export default component.exports